import { createRouter, createWebHistory } from 'vue-router';
import home from '../views/home';
import login from '../views/login';
import order from '../views/order/index.vue';
import commissionreport from '../views/commission/report.vue';
import contract from '../views/contract/index.vue';
import report from '../views/report';
import reportContract from '../views/reportContract';
import getContractNumber from '../views/getContractNumber';
import operation from '../views/operation';
import demo from '../views/demo';
import AMContractSummary from '../views/finance/AMContractSummary';
import AAContractSummary from '../views/finance/AAContractSummary';
import GPContractSummary from '../views/finance/GPContractSummary';
import tasklist from '../views/tasklist';
import test from '../views/newUI/OrderList';
import test2 from '../views/newUI/test2';
import newOrder from '../views/newUI/NewOrderForm';
import testuser from '../views/newUI/testUser';
import tcTemplate from '../views/admin/tandcTemplate';
import tcSetting from '../views/admin/tandcSetting';
import TestTandC from '../views/admin/testTandC';
import UserManage from '../views/admin/userManage';
import SystemManage from '../views/admin/systemManage';
import MyTask from '../views/report/myTask';
import ProcessManage from '../views/admin/processManage';
import ContractManage from '../views/admin/contractManage';
import ContractListByItem from '../views/contractListByItem';
import KingdeeSync from '../views/finance/KingdeeSync';

const routes = [
  {
    path: '/',
    name: ' ',
    component: report,
  },
  {
    path: '/home',
    name: 'home',
    component: home,
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/contract',
    name: 'contract',
    component: contract,
  },
  {
    path: '/commissionreport',
    name: 'commissionreport',
    component: commissionreport,
  },
  {
    path: '/order',
    name: 'order',
    component: order,
    props: {
      mode: '',
      id: 0,
      key: 0,
    },
  },
  {
    path: '/report',
    name: 'report',
    component: report,
  },
  {
    path: '/reportContract',
    name: 'reportContract',
    component: reportContract,
  },
  {
    path: '/getContractNumber',
    name: 'getContractNumber',
    component: getContractNumber,
  },
  {
    path: '/operation',
    name: 'operation',
    component: operation,
  },
  {
    path: '/demo',
    name: 'demo',
    component: demo,
    props: {
      key: 0,
    },
  },
  {
    path: '/AMContractSummary',
    name: 'AMContractSummary',
    component: AMContractSummary,
  },
  {
    path: '/AAContractSummary',
    name: 'AAContractSummary',
    component: AAContractSummary,
  },
  {
    path: '/GPContractSummary',
    name: 'GPContractSummary',
    component: GPContractSummary,
  },
  {
    path: '/tasklist',
    name: 'tasklist',
    component: tasklist,
  },
  {
    path: '/test',
    name: 'test',
    component: test,
  },
  {
    path: '/test2',
    name: 'test2',
    component: test2,
  },
  {
    path: '/newOrder1',
    name: 'newOrder',
    component: newOrder,
  },
  {
    path: '/testuser',
    name: 'testuser',
    component: testuser,
  },
  {
    path: '/tandcTemplate',
    name: 'tandcTemplate',
    component: tcTemplate,
  },
  {
    path: '/tandcSetting',
    name: 'tandcSetting',
    component: tcSetting,
  },
  {
    path: '/testTandC',
    name: 'testTandC',
    component: TestTandC,
  },
  {
    path: '/UserManage',
    name: 'UserManage',
    component: UserManage,
  },
  {
    path: '/SystemManage',
    name: 'SystemManage',
    component: SystemManage,
  },
  {
    path: '/MyTask',
    name: 'MyTask',
    component: MyTask,
  },
  {
    path: '/ProcessManage',
    name: 'ProcessManage',
    component: ProcessManage,
  },
  {
    path: '/ContractManage',
    name: 'ContractManage',
    component: ContractManage,
  },
  {
    path: '/ContractListByItem',
    name: 'ContractListByItem',
    component: ContractListByItem,
  },
  {
    path: '/MediaSummary',
    name: 'MediaSummary',
    component: () => import('../views/mediaSummary/index.vue'),
  },
  {
    path: '/KingdeeSync',
    name: 'KingdeeSync',
    component: KingdeeSync,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
